<template>
    <div class="specs-list">
        <div class="grid grid-cols-5 gap-1">
            <div v-for="content in sorted" class="text-sm" :class="{disabled: loading}">
                <component :is="content?.type" :spec="spec" :content="content" :key="content.value"/>
                <input type="checkbox" :id="spec.id+content.value" class="auto-submit w-0 h-0 hidden" :checked="is_selected(content.value)" @change="check(content.value)">
            </div>
        </div>
        <div v-if="!searched && spec.values.length > sliced" @click="show_all = !show_all" class="text-xs mt-1 text-muted hover:text-primary cursor-pointer">
            <span v-if="!show_all">Mostra Altro</span>
            <span v-else >Nascondi</span>
        </div>
    </div>
</template>

<script>

import icons from "./circle_components/icons.vue";
import color from "./circle_components/color.vue";
import images from "./circle_components/images.vue";

export default {
    name: "circle_checkbox",
    props: ['spec', 'changeSpecs', 'loading', 'selected_specs', 'getSpec'],
    components: {images, color, icons},
    data: () => ({
        show: true,
        searched: null,
        filtered: null,
        show_all: false
    }),
    methods: {
        is_selected: function (val) {
          return this.getSpec(this.spec.id).indexOf(val) > -1
        },
      check: function (val) {
        let vals = this.getSpec(this.spec.id);
        let index = vals.indexOf(val);
        if (this.is_selected(val)) {
          vals.splice(index, 1)
        } else vals.push(val);
        this.changeSpecs(this.spec.id, vals)
      },
    },
    mounted() {
        this.filtered = JSON.parse(JSON.stringify(this.$props.spec.values));
    },
    watch: {
        searched: function () {
            if (this.searched !== null) {
                this.filtered = this.$props.spec.values.filter(v => v.name && v.name.toUpperCase().includes(this.searched.toUpperCase()));
            } else this.filtered = JSON.parse(JSON.stringify(this.$props.spec.values));
        },
        spec: function () {
            this.filtered = JSON.parse(JSON.stringify(this.$props.spec.values));
        }
    },
    computed: {
        sorted: function () {
            if (this.filtered) {
                let a = this.filtered.sort((v1, v2) => {
                    v1.name.toUpperCase().localeCompare(v2.name.toUpperCase());
                }).sort((v1, v2) => this.is_selected(v2.value) - this.is_selected(v1.value));
                if (this.searched) return a;
                return this.show_all ? a : a.slice(0, this.sliced);
            }
            return JSON.parse(JSON.stringify(this.$props.spec.values));
        },
        sliced: function () {
            return Math.max((Math.abs(this.$props.spec.values.length - 5) < 5 ? this.$props.spec.values.length : 5),
                this.$props.spec.values.filter(v => this.is_selected(v.value)).length);
        }
    }
}
</script>
